<template>
  <span></span>
</template>
<script>
import { parseISO, addDays, isAfter } from 'date-fns';

export default {
  name: 'ShowUpdateProfileAlert',
  props: ['hasCompletedProfile'],
  mounted() {
    const nextNotificationDate = localStorage.getItem('nextNotificationDate');
    const timePassed = isAfter(new Date(), parseISO(nextNotificationDate));

    if (!this.hasCompletedProfile && (timePassed || !nextNotificationDate)) {
      setTimeout(() => {
        this.$toasted.show('Please take a few seconds to update your profile by filling in the new Ethnicity field.', {
          theme: 'none',
          position: 'top-left',
          duration: null,
          className: 'mb-2',
          containerClass: 'bg-primary-100 text-primary-900 text-md rounded-md w-1/2',
          action: [
            {
              text: 'Edit Profile',
              class: 'text-primary-900 font-semibold',
              onClick: () => {
                localStorage.setItem('nextNotificationDate', addDays(new Date(), 3));
                window.location.href = '/profile/edit';
                this.$toasted.clear();
              },
            },
            {
              text: 'Close',
              class: 'text-primary-900 font-semibold',
              onClick: () => {
                localStorage.setItem('nextNotificationDate', addDays(new Date(), 3));
                this.$toasted.clear();
              },
            },
          ],
        });
      }, 3000);
    }
  },
};
</script>
